import { render, staticRenderFns } from "./InspectionViewInspectionSectionModal.vue?vue&type=template&id=20b79d68"
import script from "./InspectionViewInspectionSectionModal.vue?vue&type=script&lang=js"
export * from "./InspectionViewInspectionSectionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports